module.exports = __webpack_public_path__ + "static/media/CoreyOverstreet.211907ed.jpg";